<template>
  <div class="accounting-fee-fields">
    <section v-for="group in groups" :key="group.key" class="fee-section" :class="'fee-section--' + group.key">
      <div class="fee-section-title">
        <span>{{ group.title }}</span><span class="fee-section-hint">{{ group.hint }}</span>
      </div>
      <div class="fee-field-grid">
        <el-form-item v-for="field in group.fields" :key="field.key" :label="field.label" :prop="field.key" label-width="88px">
          <el-input-number :value="value[field.key] == null ? 0 : Number(value[field.key])"
            :min="0" :precision="2" controls-position="right" @input="updateFee(field.key, $event)" />
        </el-form-item>
      </div>
    </section>
    <div class="fee-result">
      <div class="fee-result-total"><span>核算费用</span><strong :class="{ 'fee-result-negative': Number(total) < 0 }">{{ total }}<small> 元</small></strong></div>
      <div class="fee-result-formula">安装费 − 漏保扣款 − 保险扣款 + 三项补贴</div>
    </div>
  </div>
</template>

<script>
import { accountingFee } from '@/utils/accountingFee';
import Big from 'big.js';

export default {
  name: 'AccountingFeeFields',
  props: { value: { type: Object, required: true } },
  data() {
    return {
      groups: [
        { key: 'base', title: '基础费用', hint: '单位：元', fields: [{ key: 'installFee', label: '安装费' }] },
        { key: 'deduction', title: '− 扣款项', hint: '填写正数，核算时减去', fields: [
          { key: 'leakageDeduction', label: '漏保扣款' }, { key: 'insuranceDeduction', label: '保险扣款' },
        ] },
        { key: 'subsidy', title: '+ 补贴项', hint: '核算时加上', fields: [
          { key: 'regionalSubsidy', label: '区域补贴' }, { key: 'specialSubsidy', label: '特殊补贴' },
          { key: 'monthlySubsidy', label: '月度补贴' },
        ] },
      ],
    };
  },
  computed: { total() { return new Big(accountingFee(this.value)).toFixed(2); } },
  methods: { updateFee(key, amount) { this.$emit('input', { ...this.value, [key]: amount == null ? 0 : amount }); } },
};
</script>

<style scoped>
.accounting-fee-fields { width: 100%; }
.fee-section { margin-bottom: 12px; padding: 14px 12px; border: 1px solid #ebeef5; border-radius: 6px; }
.fee-section-title { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 6px; margin-bottom: 12px; color: #303133; font-weight: 600; }
.fee-section-hint { color: #909399; font-size: 12px; font-weight: 400; }
.fee-section--deduction { border-color: #fde2e2; background: #fff8f7; }
.fee-section--deduction .fee-section-title { color: #c45656; }
.fee-section--subsidy { border-color: #e1f3d8; background: #f8fcf5; }
.fee-section--subsidy .fee-section-title { color: #529b2e; }
.fee-field-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.fee-field-grid .el-form-item { margin-bottom: 0; }
.fee-field-grid .el-input-number { width: 100%; }
.fee-result { padding: 2px 4px 12px; }
.fee-result-total { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; color: #303133; }
.fee-result-total strong { color: #409eff; font-size: 22px; font-variant-numeric: tabular-nums; }
.fee-result-total small { font-size: 12px; font-weight: 400; }
.fee-result-total .fee-result-negative { color: #c45656; }
.fee-result-formula { margin-top: 5px; color: #909399; font-size: 12px; line-height: 1.5; }
@media (max-width: 600px) { .fee-field-grid { grid-template-columns: 1fr; } }
</style>
